//! вывод годов в фильтр от 2025 и далее по факту наступления след года
export const years = generateYears(2025, new Date().getFullYear());

function generateYears(fromYear: number, toYear: number) {
  const years = [];
  for (let year = fromYear; year <= toYear; year++) {
    years.push({ ID: year - fromYear + 1, Title: String(year) });
  }
  return years;
}

export const months = [
  { ID: 1, Title: 'Январь' },
  { ID: 2, Title: 'Февраль' },
  { ID: 3, Title: 'Март' },
  { ID: 4, Title: 'Апрель' },
  { ID: 5, Title: 'Май' },
  { ID: 6, Title: 'Июнь' },
  { ID: 7, Title: 'Июль' },
  { ID: 8, Title: 'Август' },
  { ID: 9, Title: 'Сентябрь' },
  { ID: 10, Title: 'Октябрь' },
  { ID: 11, Title: 'Ноябрь' },
  { ID: 12, Title: 'Декабрь' },
];

export const randomScope = () => {
  return Math.round(Math.random() * 100);
};

export const listNamesReportStatus = ['years', 'months', 'groups', 'factory'];

export const filterConfigReportStatus = {
  year: {
    title: 'Год',
    hasSearch: false,
    searchPlaceholder: 'Поиск по году',
    options: years.map((item) => item.Title),
  },
  month: {
    title: 'Месяц',
    hasSearch: true,
    searchPlaceholder: 'Поиск по месяцу',
    options: months.map((item) => item.Title),
  },

  groupReportPeriod: {
    title: 'Группа',
    hasSearch: true,
    searchPlaceholder: 'Поиск по группе',
    options: [],
  },
  factoryReport: {
    title: 'Завод',
    hasSearch: true,
    searchPlaceholder: 'Поиск по заводу',
    options: [],
  },
};

// const getCurrentDate = () => {
//   const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
//   const currentDate = new Date();
//   const currentYear = currentDate.getFullYear();
//   const currentMonthIndex = currentDate.getMonth();

//   return {
//     month: {
//       id: currentMonthIndex + 1,
//       name: months[currentMonthIndex],
//     },
//     year: {
//       id: currentYear,
//       name: currentYear.toString(),
//     },
//   };
// };

// const currentDate = getCurrentDate();

// export const initialFilterReportStatus = {
//   year: {
//     selected: [currentDate.year.name],
//     selectedIds: [currentDate.year.id],
//     search: '',
//   },
//   month: {
//     selected: [currentDate.month.name],
//     selectedIds: [currentDate.month.id],
//     search: '',
//   },

//   factoryReport: { selected: [], selectedIds: [], search: '' },
//   groupReportPeriod: { selected: [], selectedIds: [], search: '' },
// };

export const filtersOpenReportStatus = {
  year: false,
  month: false,

  factoryReport: false,
  groupReportPeriod: false,
};
